import { auth, AuthActions, AuthState } from '@virtus/common/auth/reducer';
import { combineReducers } from 'redux';
// @ts-ignore // redux-query type declaration is not yet available
import { entitiesReducer as entities, queriesReducer as queries } from 'redux-query';
import { inspector, InspectorActions, InspectorState } from './inspector';
import { appBar, AppBarActions, AppBarState } from './appBar';
import { dateRangeSelector, DateRangeSelectorActions, DateRangeSelectorState } from './dateRangeSelector';
import { ApiTelemetrySelectorActions, ApiTelemetrySelectorState, apiTelemetrySelector } from './apiTelemetrySelector';

/**
 * Define all actions
 */
export type Actions =
  | AuthActions
  | InspectorActions
  | AppBarActions
  | DateRangeSelectorActions
  | ApiTelemetrySelectorActions;

/**
 * Define the whole State
 */
export type RootState = {
  auth: AuthState;
  appBar: AppBarState;
  inspector: InspectorState;
  entities: any;
  queries: any;
  dateRangeSelector: DateRangeSelectorState;
  apiTelemetrySelector: ApiTelemetrySelectorState;
};

/**
 * define Root Reducer
 */
export const rootReducer = combineReducers<RootState>({
  auth,
  appBar,
  inspector,
  entities,
  queries,
  dateRangeSelector,
  apiTelemetrySelector,
});

export default rootReducer;
